module.exports = __webpack_public_path__ + "static/img/heroimage_wallet_large2.d2ae954.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/heroimage_wallet_large2.png
// module id = 245
// module chunks = 1